import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import IconMail from '@/shared/icons/NewDesign/IconMail'
import type { SendPanelProps } from '../types'
import { StyledButtonBlock, StyledHint, StyledScript } from '../styled-components'

const SendPanel = ({ hidden, script, info, action }: SendPanelProps) => {
  const isPulse = usePulseScope()

  if (hidden) {
    return null
  }

  return (
    <>
      <StyledScript $pulse={isPulse} dangerouslySetInnerHTML={{ __html: script }} />
      <StyledButtonBlock>
        {/* @ts-ignore */}
        <SDButton
          block={true}
          disabled={action.disabled}
          isLoading={action.loading}
          onClick={action.onClick}
          startEnhancer={<IconMail />}
        >
          {action.label}
        </SDButton>
      </StyledButtonBlock>
      <StyledHint>{info}</StyledHint>
    </>
  )
}

export default SendPanel
